import { EventDetails, TrackingEvents, TrackingStage } from '@/config/tracking';
import { AllFlyerFilters } from '@/graphql/types';
import { TrackingFrom } from '@/hooks';
import { createContext, useContext } from 'react';

export type DrawerFilters = Pick<
  AllFlyerFilters,
  'owningType' | 'categories' | 'grades' | 'isCommunityFree' | 'schoolIds'
>;

export type JarFlyerboardContextType = {
  toggleQuickFilter: (tag: string) => void;
  drawerFilters: DrawerFilters;
  setDrawerFilters: (value: DrawerFilters) => void;
  filters?: AllFlyerFilters;
  resetQuickFilters: () => void;
  amountActiveFilters: number;
  districtId?: string;
  trackingFrom: TrackingFrom;
};

const JarFlyerboardContext = createContext<JarFlyerboardContextType>({
  toggleQuickFilter: (tag: string) => null,
  resetQuickFilters: () => null,
  amountActiveFilters: 0,
  drawerFilters: {
    schoolIds: [],
  },
  setDrawerFilters: (value?: DrawerFilters) => null,
  districtId: undefined,
  filters: {
    allDistrictSchools: false,
    schoolIds: [],
    categories: [],
    grades: [],
    isNew: false,
    isCommunityFree: false,
  },
  trackingFrom: {
    stage_from: TrackingStage.discovery,
    event_from: TrackingEvents.viewFlyerSet,
    event_detail_from: EventDetails.viewFlyerSet('jar'),
  },
});

export const useJarFlyerboardContext = () => useContext(JarFlyerboardContext);

export default JarFlyerboardContext;
